import { assertNotEmpty } from '@festina-life/core'
import { useCallback } from 'react'

import { useConfigurationContext } from '../../../context/configurationContext'
import {
  getTemplateOperationAtDate,
  templateIdFromPath,
} from '../../../uiModels/templateOperations/helpers'
import { useApplicationViewOperationsContext } from '../../../workspace/applicationViewOperationsContext'

export const useTemplateOperationKeyFromPath = () => {
  const { viewAt } = useConfigurationContext()
  const { applicationTemplates: applicationTemplateOperations } =
    useApplicationViewOperationsContext()

  return useCallback(
    (path: string) => {
      const variantTemplateId = templateIdFromPath(path)
      const indexedTemplateOperations =
        applicationTemplateOperations.get(variantTemplateId)
      const operationForDate = getTemplateOperationAtDate(
        indexedTemplateOperations,
        viewAt,
      )

      assertNotEmpty(operationForDate)

      return operationForDate.internalOperation.operationKey
    },
    [applicationTemplateOperations, viewAt],
  )
}
